import styles from './AppUsage.module.scss';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
export const appUsageTableConfig = () => {
  return [
    {
      id: 'no',
      name: '#',
      sortable: false,
      cellRenderer: (row, rowIndex) => {
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
            className={styles.numberCell}
          >
            {rowIndex + 1}
          </Text>
        );
      },
    },
    {
      id: 'applicationName',
      name: 'Application Name',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
            className={styles.appNameCell}
          >
            {row.appName}
          </Text>
        );
      },
    },
    {
      id: 'timeSpent',
      name: 'Time Spent',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
            className={styles.timeSpentCell}
          >
            {row.formattedTime}
          </Text>
        );
      },
    },
  ];
};
